// extracted by mini-css-extract-plugin
module.exports = {"navLink":"style-module__navLink___DlRzF"};